import { Body, Caption, Flex } from '@teko/ds-desktop';
import { useProductDetailState, useTenantConfig } from 'contexts';
import { t } from 'i18n';
import dynamic from 'next/dynamic';
import React, { useMemo } from 'react';
import { UomItem } from './UomItem';

const OldProductVariantItem = dynamic(() =>
  import('./ProductVariantItem').then((mod) => mod.ProductVariantItem),
);

const NewProductVariantItem = dynamic(() =>
  import('./NewLayoutComponents/ProductVariantItem').then(
    (mod) => mod.ProductVariantItem,
  ),
);

export const ProductVariants: React.FC = () => {
  const { product, onSelectVariant } = useProductDetailState();
  const { productOptions, clearanceTypeDescription, sku } = product || {};
  const { fixedVariants, epicOmni1643, isDisplayUom } = useTenantConfig();

  const ProductVariantItem = epicOmni1643
    ? NewProductVariantItem
    : OldProductVariantItem;

  // UX4BUYER-6250: hardcode variants for phongvu
  const variants = useMemo(() => {
    const orgVariants = productOptions?.rows;
    if (!orgVariants) return;
    if (!fixedVariants || !sku) return orgVariants;

    const fixedVariant = fixedVariants[sku];
    if (!fixedVariant) return orgVariants;

    return orgVariants.map((variant) => {
      const fixedVariantOptions = fixedVariant[variant.title];
      if (fixedVariantOptions) {
        const options = fixedVariantOptions.map((opt) => {
          const existingOption = variant.options.find(
            (option) => option.label === opt.label,
          );
          return {
            label: opt.label,
            url: opt.url,
            sku: opt.sku,
            quantity: 1,
            selected: !!existingOption,
          };
        });
        return {
          title: variant.title,
          options,
        };
      } else {
        return variant;
      }
    });
  }, [fixedVariants, productOptions?.rows, sku]);

  if (isDisplayUom && epicOmni1643 && product?.uomName) {
    return (
      <Flex direction="column" backgroundColor="white" gap="s4">
        <Body level={1} color="textPrimary">
          {t('Đơn vị tính')}:
        </Body>
        <UomItem />
      </Flex>
    );
  }

  if (!productOptions?.rows.length) return null;

  return variants ? (
    <>
      {variants.map((variant, index) => (
        <ProductVariantItem
          key={index}
          variant={variant}
          onSelect={onSelectVariant}
        />
      ))}
      {!!clearanceTypeDescription && (
        <Caption level={1} color="textSecondary">
          {clearanceTypeDescription}
        </Caption>
      )}
    </>
  ) : (
    <React.Fragment />
  );
};
